import { Star } from "lucide-react";
import { PRAISE } from "@/lib/content";

// Slow horizontal marquee of reader reviews.
function Card({ p }) {
  return (
    <article
      data-testid="praise-card"
      className="mx-4 flex w-[86vw] max-w-[420px] shrink-0 flex-col justify-between border border-white/10 bg-void p-6 sm:mx-6 sm:w-[440px] sm:p-8 md:w-[520px] md:p-10"
    >
      <div>
        <div className="mb-5 flex items-center gap-1">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star
              key={i}
              className={`h-4 w-4 ${i < p.stars ? "fill-rebellion text-rebellion" : "text-white/20"}`}
            />
          ))}
        </div>
        <p className="font-editorial text-lg leading-relaxed text-paper md:text-xl">
          &ldquo;{p.quote}&rdquo;
        </p>
      </div>
      <footer className="mt-8 flex items-center justify-between border-t border-white/10 pt-5">
        <span className="font-display text-lg uppercase tracking-tight text-paper">
          {p.author}
        </span>
        <span className="font-mono text-[0.6rem] uppercase tracking-[0.3em] text-white/40">
          {p.source}
        </span>
      </footer>
    </article>
  );
}

export default function Praise() {
  const items = [...PRAISE, ...PRAISE];
  return (
    <section
      data-testid="praise-section"
      className="relative overflow-hidden border-t border-white/10 bg-panel py-20 md:py-28"
    >
      <div className="mx-auto mb-10 max-w-7xl px-6 md:mb-14 md:px-12">
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-rebellion">
          Early Praise
        </p>
        <h2 className="font-display text-4xl uppercase leading-[0.95] tracking-tight text-paper sm:text-5xl md:text-6xl">
          The rebellion has <span className="text-rebellion">readers.</span>
        </h2>
      </div>

      <div className="relative">
        <div className="flex w-max animate-marquee items-stretch" style={{ animationDuration: "60s" }}>
          {items.map((p, i) => (
            <Card key={i} p={p} />
          ))}
        </div>
        {/* fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-panel to-transparent md:w-40" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-panel to-transparent md:w-40" />
      </div>
    </section>
  );
}
